import { Link } from "react-router-dom";
import { StatusChip } from "./RegulationRadar";
import { sectorTrack } from "./SectorHero";
import { CountryFlag } from "@/components/CountryFlag";

const JurisdictionCard = ({ j }: { j: any }) => (
  <div data-testid={`jurisdiction-${j.code}`}
    className="rounded-xl border border-white/[0.08] bg-[#0b0c10] p-4 sm:p-5 flex flex-col">
    <div className="flex items-center gap-3">
      <CountryFlag country={j.jurisdiction} size={36} />
      <div className="min-w-0">
        <p className="text-white font-heading font-bold text-[15px] leading-tight truncate">{j.jurisdiction}</p>
        <p className="font-mono text-[9px] uppercase tracking-wide text-gray-500 mt-0.5"
          title="Published stories, last 7 days, passing digital-asset policy validation and matching this jurisdiction in the story text">
          {j.stories_7d} validated {j.stories_7d === 1 ? "story" : "stories"} · 7D
        </p>
      </div>
    </div>
    <div className="mt-3.5 space-y-2.5">
      {(j.regulations || []).map((r: any) => (
        <Link key={r.slug} to={`/regulation/${r.slug}`}
          onClick={() => sectorTrack("jurisdiction_regulation_click", r.slug, "policy")}
          className="group flex items-start gap-2.5">
          <StatusChip status={r.status} />
          <span className="text-gray-300 text-[12.5px] leading-snug line-clamp-2 group-hover:text-white transition-colors">
            {r.title}
          </span>
        </Link>
      ))}
    </div>
    {(j.agencies || []).length > 0 && (
      <div className="flex flex-wrap gap-1.5 mt-auto pt-3.5">
        {j.agencies.map((a: string) => (
          <span key={a} className="rounded-full border border-white/[0.12] bg-white/[0.04] px-2 py-0.5 font-mono text-[9px] uppercase tracking-wide text-gray-400">
            {a}
          </span>
        ))}
      </div>
    )}
  </div>
);

/* Jurisdiction Status — tracked frameworks + validated coverage per jurisdiction */
export const JurisdictionStatus = ({ items }: { items: any[] }) => {
  if (!items.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-8" data-testid="policy-jurisdictions">
      <div className="flex items-center gap-2.5 mb-1.5">
        <span aria-hidden className="h-3.5 w-[3px] rounded-full bg-[#A78BFA]" />
        <h2 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#A78BFA]">Jurisdiction Status</h2>
      </div>
      <p className="text-gray-500 text-[13px] mb-4">
        Tracked regulatory frameworks and validated NewsLayer policy coverage, by jurisdiction.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((j) => <JurisdictionCard key={j.jurisdiction} j={j} />)}
      </div>
    </section>
  );
};
